import { useState, FC } from "react";
import Button from "components/Button";
import {
  ModalContent,
  ModalSections,
  ModalButtonsSection,
} from "components/Modal";
import { useCustomizeColumns } from "hooks/analytics";
import { CustomizeColumnCheckbox } from "./shared";

export const CustomizeColumnsModalContent: FC<{
  onCancel: () => void;
  tableHeaders: { key: string; label: string; tooltip?: string }[];
  tableType: "domain" | "error";
}> = ({ onCancel, tableHeaders, tableType }) => {
  const { selectedColumns, setSelectedColumns } =
    useCustomizeColumns(tableType);
  const [localSelected, setLocalSelected] = useState<string[]>(selectedColumns);

  const toggleColumn = (key: string) =>
    setLocalSelected((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key],
    );

  const handleSave = () => {
    setSelectedColumns(localSelected);
    onCancel();
  };

  return (
    <ModalContent smallerGapFromButtons>
      <ModalSections>
        <div className="flex flex-col gap-4">
          <p className="text-gray-500">
            Choose columns shown in the table by default.
          </p>
          <p className="text-gray-500">
            The data you do not choose will be visible when you expand the row.
          </p>
          <div className="flex flex-col gap-3">
            {tableHeaders.map(({ key, label }) => (
              <CustomizeColumnCheckbox
                key={key}
                id={key}
                label={label}
                checked={localSelected.includes(key)}
                onChange={() => toggleColumn(key)}
              />
            ))}
          </div>
        </div>
      </ModalSections>
      <ModalButtonsSection justifyBetween="justify-between">
        <Button
          text="Cancel"
          className="button button-tertiary"
          onClick={() => {
            setLocalSelected(selectedColumns);
            onCancel();
          }}
          size="MD"
        />
        <Button
          text="Save"
          className="button button-primary"
          onClick={handleSave}
          size="MD"
        />
      </ModalButtonsSection>
    </ModalContent>
  );
};
